import styled from 'styled-components'

const shadows = `rgba(0, 0, 0, 0.14) 0px 1px 3px 0px,
rgba(0, 0, 0, 0.06) 0px 1px 2px 0px;`

export const FormTabs = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: calc(
        100vh - ${(props) => {return props.theme.headerHeight}}px
            - ${(props) => {return props.theme.footerHeight}}px
    );

    form {
        width: 1100px;
        max-width: 97%;
        padding: 20px 60px;
        background-color: white;
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
        box-shadow: ${(props) => {return props.theme.shadow}};
        margin-bottom: 20px;

        @media screen and (max-width: 900px) {
            padding: 10px;
            margin-bottom: 10px;
        }

        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }

        input[type=number] {
            -moz-appearance: textfield;
        }

        .btn {
            color: #0009;
            font-size: .9rem;
        }

        button[type=submit] {
            padding: 1px 15px 0;
            font-size: 1rem;
        }

        .img-container {
            border-radius: 8px;
            padding: 10px;
            background-color: white;
            box-shadow: ${shadows};
            user-select: none;

            img {
                width: 100%;
                object-fit: cover;
            }
        }

        input[type="file"] {
            display: none;
        }

        .fileLabel {
            padding: 5px 0;
            width: 100%;

            .btn {
                color: #000d;
                border: 1px solid #0006;
                background-color: #1A354906;

                &:hover {
                    box-shadow: ${shadows};
                }
            }
        }

        .imgLink {
            color: #0008;
            font-size: .9rem;
            margin: 0;
        }

        .validator {
            font-size: .8rem;
            color: #dc3545;
            display: none;

            &.visible {
                display: initial;
            }
        }

        .optionContainer {
            .option:hover {
                background-color: #0001;
                color: initial;
            }
        }
    }
`

export const FormHeader = styled.div`
    width: 1100px;
    max-width: 97%;
    background-color: ${(props) => {return props.theme.colorSecoundary}};
    margin-top: 30px;
    padding: 15px 60px 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    box-shadow: ${(props) => {return props.theme.shadow}};
    user-select: none;

    @media screen and (max-width: 900px) {
        margin-top: 10px;
        padding: 15px 10px 0;
    }

    h1 {
        font-size: 2rem;
        font-weight: 700;
        margin: 10px 0 25px;
        color: #1A3549ee;
        text-align: center;
    }

    .tabBar {
        display: flex;
        flex-wrap: wrap;
        font-size: .9rem;
        font-weight: 500;
        color: #0006;

        div {
            z-index: 1;
            transition: 300ms ease-in-out;
            padding: 4px 12px 0;

            &.current {
                border-top-left-radius: 4px;
                border-top-right-radius: 4px;
                background-color: white;
                color: #1A3549DD;
                box-shadow: rgba(0, 0, 0, 0.1) 0px -1px 2px 0px;
            }
        }
    }
`

export const Progress = styled.div`
    background-color: white;
    height: 20px;
    border-radius: 6px;
    overflow: hidden;
    user-select: none;
    margin: 10px 0;
    border: 1px solid #0003;

    div {
        background-color: ${(props) => {return props.theme.colorPrimary}};
        width: 0;
        height: 100%;
        transition: 1s ease-in-out;
    }
`
